import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Stack, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { useSnackbar } from "notistack";
import React from "react";
import { ApiError } from "../../Api/ApiError";
import { editMembershipData, getCustomerDetail } from "../../Api/Customer";
import { CustomerDetailInterface } from "../../Objects/Customer";
import CustomerCard from "../molecules/CustomerCard";

export interface MemeberInfoEditDialogProps {
    ctmId?: number
    dialogProps?: Omit<DialogProps, "open">
    onClose: () => void
}
export function MemeberInfoEditDialog({
    ctmId,
    dialogProps,
    onClose,
}: MemeberInfoEditDialogProps): React.ReactElement {
    let { enqueueSnackbar } = useSnackbar()

    const [open, setOpen] = React.useState<boolean>(false)

    const [customerDetailData, setCustomerDetailData] = React.useState<CustomerDetailInterface>()

    const [editCode, setEditCode] = React.useState<string>("")
    const [editJoinDate, setEditJoinDate] = React.useState<Date | null>(null)
    const [editRenewDate, setEditRenewDate] = React.useState<Date | null>(null)
    const [editValidityDate, setEditValidityDate] = React.useState<Date | null>(null)

    const abortController = React.useMemo(() => new AbortController(), [])

    React.useEffect(() => {
        return () => {
            abortController.abort()
        }
    }, [abortController])

    const doSave = React.useCallback(() => {
        if (ctmId) {
            //validate
            // @todo
            editMembershipData({
                ctm_id: ctmId,
                ctm_code: editCode,
                join_date: editJoinDate ? editJoinDate : undefined,
                renew_date: editRenewDate ? editRenewDate : undefined,
                validity_date: editValidityDate ? editValidityDate : undefined
            }, {signal: abortController.signal}).then(() => {
                enqueueSnackbar("登録しました", { variant: "success" })
                setOpen(false)
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    enqueueSnackbar(e.message, { variant: "error" })
                } else if (e instanceof Error) {
                    enqueueSnackbar(e.message, { variant: "error" })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })
        }
    }, [abortController, ctmId, editCode, editJoinDate, editRenewDate, editValidityDate, enqueueSnackbar])

    React.useEffect(() => {
        const controller = new AbortController()
        if (ctmId) {
            getCustomerDetail({
                accessKey: "HEAD-OFFICE_LOGIN",
                ctmId: ctmId
            }, {signal: controller.signal}).then(result => {
                setCustomerDetailData(result)
                setEditCode(result.code ? result.code : "")
                setEditJoinDate(result.join_date ? new Date(result.join_date) : null)
                setEditRenewDate(result.renew_date ? new Date(result.renew_date) : null)
                setEditValidityDate(result.validity_date ? new Date(result.validity_date) : null)
                setOpen(true)
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    enqueueSnackbar(e.message, { variant: "error" })
                } else if (e instanceof Error) {
                    enqueueSnackbar(e.message, { variant: "error" })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })
        }
        return () => {
            controller.abort()
        }
    }, [ctmId, enqueueSnackbar])

    return (
        <Dialog
            {...dialogProps}
            open={open}
            onClose={() => {
                setOpen(false)
            }}
            TransitionProps={{
                onExited: () => {
                    onClose()
                }
            }}
        >
            <DialogTitle>会員情報編集</DialogTitle>
            {customerDetailData &&
                <DialogContent>
                    <CustomerCard customer={customerDetailData} />
                    <Stack
                        spacing={2}
                        mt={2}
                    >
                        <TextField
                            label="会員番号"
                            value={editCode}
                            onChange={e => {
                                setEditCode(e.target.value)
                            }}
                            size="small"
                        />
                        <DatePicker
                            label="入会日"
                            onChange={date => {
                                setEditJoinDate(date)
                            }}
                            value={editJoinDate}
                            renderInput={params => <TextField {...params} fullWidth size="small" />}
                            inputFormat="yyyy/MM/dd"
                            mask="____/__/__"
                            clearable={true}
                            defaultCalendarMonth={null}
                        />
                        <DatePicker
                            label="更新日"
                            onChange={date => {
                                setEditRenewDate(date)
                            }}
                            value={editRenewDate}
                            renderInput={params => <TextField {...params} fullWidth size="small" />}
                            inputFormat="yyyy/MM/dd"
                            mask="____/__/__"
                            clearable={true}
                            defaultCalendarMonth={null}
                        />
                        <DatePicker
                            label="有効期限"
                            onChange={date => {
                                setEditValidityDate(date)
                            }}
                            value={editValidityDate}
                            renderInput={params => <TextField {...params} fullWidth size="small" />}
                            inputFormat="yyyy/MM/dd"
                            mask="____/__/__"
                            clearable={true}
                            defaultCalendarMonth={null}
                        />
                    </Stack>
                </DialogContent>
            }
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={() => {
                        setOpen(false)
                    }}
                >キャンセル</Button>
                <Button
                    variant="contained"
                    onClick={() => {
                        doSave()
                    }}
                >保存</Button>
            </DialogActions>
        </Dialog>
    )
}